import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';


function QualityManagement() {
  return (
    <>
<Features docname="Quality Management"/>
<Advantages docname="Quality Management"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default QualityManagement;
